/**
 * SendHelper.nineMailId 결정 헬퍼.
 *
 * ngwEditor 0.2.11 의 4-region nine-mail-id (외곽 wrapper + region id prefix) 의 source.
 * SendHelper constructor 가 매 작성 세션마다 1회 호출하며 결과는 readonly.
 *
 * 결정 규칙: 항상 `ncompose-{uuid}` 발급.
 *
 * 첫 글자 `n` 은 legacy nine_tinymce_desktop 호환을 위해 강제 — 수신측은 외곽 `<body>` 의
 * 직계 자식 `<div class="nine_body" id="nine_body_n...">` 의 id prefix 로 nine 에디터 본문을
 * 식별한다 (nine_tinymce_desktop.js:1037).
 *
 * draft reopen 시에도 동일하게 새 `ncompose-{uuid}` 가 발급된다 — JMAP `EmailObj.data.id`
 * (백엔드 email-id) 는 'n' prefix 규칙을 만족하지 않으므로 nine-mail-id 슬롯에 사용하지 않는다.
 * 두 도메인의 명명 혼선을 막기 위해 변수명도 `nineMailId` 로 통일.
 */

import { safeUUID } from 'utils/safeUUID'

export function generateNineMailId(): string {
  return `ncompose-${safeUUID()}`
}
